export enum EntityStatus {
  Todo = 0,
  Designing = 1,
  Implementing = 2,
  Implemented = 3,
  Archived = 9
}

export const EntityStatusColor: Record<EntityStatus, string> = {
  [EntityStatus.Todo]: '#739eb8',
  [EntityStatus.Designing]: '#37c2ed',
  [EntityStatus.Implementing]: '#37edc5',
  [EntityStatus.Implemented]: '#59ab5a',
  [EntityStatus.Archived]: '#a0a0a0',
};
